export const SET_WORKLIST = 'workList/SET_WORKLIST';
export const SET_CREDIT_REQUEST_BY_WORKLIST = 'workList/SET_CREDIT_REQUEST_BY_WORKLIST';
export const SET_EMPLOYEES = 'worklist/SET_EMPLOYEES';
export const SET_WORKLIST_STATUS_TYPES = 'worklist/SET_WORKLIST_STATUS_TYPES';
export const SET_WORKLIST_ERROR = 'worklist/SET_WORKLIST_ERROR';
export const SET_IS_WORKLIST_ERROR = 'worklist/SET_IS_WORKLIST_ERROR';
export const SET_EMPLOYEE_WORKLIST_ERROR = 'worklist/SET_EMPLOYEE_WORKLIST_ERROR';
